import React, { useState } from "react";
import { useSelector } from "react-redux";

import { ReportWidgetConfigs } from "constants/widgets.constant";

import PageLoading from "components/PageLoading";

import ReportChart from "../ReportChart";
import ReportComment from "../ReportComment/ReportComment";
import ReportTitle from "../Title/Title";

function ReportListItem({ item, baselineList, setUpdateReportPreview, onWidgetAction, onWidgetEnable, isToUpdateReportPreview, LayoutId }) {
  const [error, setError] = useState(item.error);
  const tags = useSelector(state => state.tags.tagsAsObj);

  const getSideColor = report => ReportWidgetConfigs[report.Type]?.color;

  return (
    <div className={`reportListContainer ${error ? "card-error" : ""}`}>
      {item.isUpdating ? (
        <PageLoading customHeight="100%" />
      ) : (
        <>
          <div className="d-flex">
            <ReportTitle
              parentStyle="flex_1  item__width--one-fourth padding-left-10 padding-right-5"
              report={item}
              baselineList={baselineList}
              tags={tags}
              onWidgetAction={onWidgetAction}
              onWidgetEnable={onWidgetEnable}
            />
            <div className="verticalLine" />
            <ReportChart
              parentStyle="flex_1 padding10 item__width--half"
              report={item}
              isToUpdateReportPreview={isToUpdateReportPreview}
              setUpdateReportPreview={setUpdateReportPreview}
              error={error}
              setError={setError}
            />
            <div className="verticalLine" />
            <ReportComment parentStyle="flex_1 item__width--one-fourth report_comment_container" report={item} LayoutId={LayoutId} />
          </div>
          <div className="sidebar" style={{ borderTopColor: getSideColor(item) }} />
        </>
      )}
    </div>
  );
}

export default ReportListItem;
